(() => {
  const mappings = [
  {
    "old": "/files/BLUE_51272d13-91c9-487e-90d7-df9870c39ef9.png",
    "next": "/files/pcf-integrated-blue-updated-render.jpg",
    "version": "1790955167",
    "alt": "PCF Integrated blue case with its silver gear loop extended, shown diagonally."
  },
  {
    "old": "/files/BLACK_415f4bab-4611-4925-bd3f-9046a1a5aa0e.png",
    "next": "/files/pcf-integrated-black-updated-render.jpg",
    "version": "1790955177",
    "alt": "PCF Integrated black case with its silver gear loop extended, shown diagonally."
  },
  {
    "old": "/files/TAUPE.png",
    "next": "/files/pcf-integrated-taupe-updated-render.jpg",
    "version": "1790955188",
    "alt": "PCF Integrated taupe case with its silver gear loop extended, shown diagonally."
  }
];
  const swatches = [
  {
    "old": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiYWNheDIyLTJ3Lm15c2hvcGlmeS5jb20vOTk0MTYyNzU2ODQyNi1UQVVQRS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
    "next": "https://cdn.shopify.com/s/files/1/0964/1577/7066/files/pcf-integrated-taupe-updated-render.jpg?v=1790955188&width=200"
  },
  {
    "old": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiYWNheDIyLTJ3Lm15c2hvcGlmeS5jb20vOTk0MTYyNzU2ODQyNi1CTFVFXzUxMjcyZDEzLTkxYzktNDg3ZS05MGQ3LWRmOTg3MGMzOWVmOS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
    "next": "https://cdn.shopify.com/s/files/1/0964/1577/7066/files/pcf-integrated-blue-updated-render.jpg?v=1790955167&width=200"
  },
  {
    "old": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiYWNheDIyLTJ3Lm15c2hvcGlmeS5jb20vOTk0MTYyNzU2ODQyNi1CTEFDS180MTVmNGJhYi00NjExLTQ5MjUtYmQzZi05MDQ2YTFhNWFhMGUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
    "next": "https://cdn.shopify.com/s/files/1/0964/1577/7066/files/pcf-integrated-black-updated-render.jpg?v=1790955177&width=200"
  }
];
  const attributes = ['src', 'srcset', 'data-src', 'data-srcset'];
  const selector = 'img, source, .bcpo-front-image-label';
  function replacement(value) {
    let result = value;
    for (const mapping of mappings) {
      result = result.split(mapping.old + '?v=1776281448').join(mapping.next + '?v=' + mapping.version);
      result = result.split(mapping.old).join(mapping.next);
    }
    return result;
  }
  function updateImage(element) {
    if (element.matches('.bcpo-front-image-label')) {
      const original = element.getAttribute('style') || '';
      let updated = original;
      for (const swatch of swatches) updated = updated.split(swatch.old).join(swatch.next);
      if (updated !== original) {
        element.setAttribute('style', updated);
        element.style.backgroundSize = 'contain';
        element.style.backgroundPosition = 'center';
        element.style.backgroundRepeat = 'no-repeat';
      }
      return;
    }
    if (!element.matches('img, source')) return;
    for (const attribute of attributes) {
      const value = element.getAttribute(attribute);
      if (!value) continue;
      const updated = replacement(value);
      if (updated !== value) element.setAttribute(attribute, updated);
    }
    if (element.tagName === 'IMG') {
      const source = element.getAttribute('src') || '';
      const mapping = mappings.find(item => source.includes(item.next));
      if (mapping && element.getAttribute('alt') !== mapping.alt) element.setAttribute('alt', mapping.alt);
    }
  }
  function updateTree(root) {
    if (root.nodeType === 1) updateImage(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(updateImage);
  }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') updateImage(record.target);
      else record.addedNodes.forEach(updateTree);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: [...attributes, 'style'] });
  updateTree(document);
})();
